import {
  Box,
  Checkbox,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import React from "react";
import {
  EnhancedTableHead,
  EnhancedTableToolbar,
} from "../../../../components/CustomTable";
import { useDispatch } from "react-redux";
import { sendDisableUser } from "../../../../store/users/users.action";
import { CustomPagination } from "../../../../components/CustomTable/CustomTable";
import TraderFilter from "./TraderFilter";
import Loading from "../../../../assets/images/loading.svg";

type Order = "asc" | "desc";
interface HeadCell {
  disablePadding: boolean;
  id: any;
  label: string;
  numeric: boolean;
  isShow: boolean;
}

const headCells: readonly HeadCell[] = [
  {
    id: "id",
    numeric: true,
    disablePadding: true,
    label: "User ID",
    isShow: true,
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "Email",
    isShow: true,
  },
  {
    id: "f_name",
    numeric: false,
    disablePadding: false,
    label: "Name",
    isShow: true,
  },
  {
    id: "mobile",
    numeric: false,
    disablePadding: false,
    label: "Phone Number",
    isShow: true,
  },
  {
    id: "gender",
    numeric: false,
    disablePadding: false,
    label: "Gender",
    isShow: true,
  },
  {
    id: "action",
    numeric: false,
    disablePadding: false,
    label: "Action",
    isShow: true,
  },
];

const RetailerTable = ({
  retailerUsers: { users, pages, page: maxPage, limit, roleId,f_name,l_name,email,mobile },
  onFetchUsersBasedOnRolesStart,
  onChangeApplyTraderFilter, loading,
}) => {
  // console.log("limit---->", limit);
  const dispatch = useDispatch();
  const [selected, setSelected] = React.useState<readonly string[]>([]);
  const [dense, setDense] = React.useState(false);
  const [order, setOrder] = React.useState<Order>("asc");
  const [orderBy, setOrderBy] = React.useState<any>("id");
  const [noOfPages, setNoOfPages] = React.useState([]);

  const [activePage, setActivePage] = React.useState<any>(1);

  const [rowsPerPage, setRowsPerPage] = React.useState(limit);

  const [page, setPage] = React.useState(0);
  

  const isSelected = (id: any) => selected.indexOf(id) !== -1;
  const label = { inputProps: { "aria-label": "Switch demo" } };
  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = users?.map((n: any) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  React.useEffect(() => {
    const calculatePages = () => {
      const totalPages = Math.ceil(pages?.total / limit);
      const newPages = [];
      for (let i = 1; i <= totalPages; i++) {
        newPages.push(i);
      }
      setNoOfPages(newPages);
    };

    calculatePages();
  }, [pages?.total, limit]);

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    dispatch(
      onChangeApplyTraderFilter("limit", Number(event.target.value), "retailer")
    );
    onFetchUsersBasedOnRolesStart(5, 'asc', 'name');
  };

  const handlePageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(onChangeApplyTraderFilter("page", event.target.value, "retailer"));
    setActivePage(Number(event.target.value));
    onFetchUsersBasedOnRolesStart(5, 'asc', 'name');
  };

  React.useEffect(() => {
    onFetchUsersBasedOnRolesStart(5, 'asc', 'name');
  }, []);

  const handleSwitchChange = (id) => {
    dispatch(sendDisableUser(id));
    // onFetchUsersStart();
    onFetchUsersBasedOnRolesStart(5);
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - users?.length) : 0;

    const handleRequestSort = (field) => {
      const isAsc = orderBy === field && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(field);
  
      onFetchUsersBasedOnRolesStart(5, isAsc ? "asc" : "desc", field);
    };

  const getComparator = (order, orderBy) => {
    return order === 'desc'
      ? (a, b) => (b[orderBy] < a[orderBy] ? -1 : 1)
      : (a, b) => (a[orderBy] < b[orderBy] ? -1 : 1);
  };

  const sortedData = users ? users.sort(getComparator(order, orderBy)) : [];


  const showNextPage = () => {
    dispatch(onChangeApplyTraderFilter("page", activePage + 1, "retailer"));
    setActivePage(activePage + 1);
    onFetchUsersBasedOnRolesStart(5, 'asc', 'name');
  };

  const showPrevPage = () => {
    dispatch(onChangeApplyTraderFilter("page", activePage - 1, "retailer"));
    setActivePage(activePage - 1);
    onFetchUsersBasedOnRolesStart(5, 'asc', 'name');
  };


  const handleSearchChange = (e, filterName) => {
    dispatch(onChangeApplyTraderFilter("f_name", e, filterName));
    onFetchUsersBasedOnRolesStart(5, 'asc', 'name');
  };

  const handleCheckboxClick = (id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
  
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
  
    setSelected(newSelected);
  };

  
  return (
    <Box sx={{ width: "100%" }}>
      <Paper sx={{ width: "100%", mb: 2 }}>
        <EnhancedTableToolbar numSelected={selected?.length} handleChange={(e) => handleSearchChange(e, "retailer")} tableHeaderComps={
            <TraderFilter
              filterName="retailer"
              f_name={f_name}
              l_name={l_name}
              email={email}
              mobile={mobile}
              onFetchUsersBasedOnRolesStart={ onFetchUsersBasedOnRolesStart}
             
            />
          }/>
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={(event, property) => handleRequestSort(property)}
              rowCount={sortedData?.length}
              headCells={headCells}
            />
            <TableBody>

            {loading && users.length === 0 ? (
              <TableRow>
                <TableCell colSpan={headCells.length} align="center">
                  {/* Loading... */}
                  <img src={Loading}/>
                </TableCell>
              </TableRow>
              ) : users.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={headCells.length} align="center">
                    No Data Available
                  </TableCell>
                </TableRow>
              )
                // {/* { */}
              : (
               sortedData && sortedData?.length > 0 ? (
                sortedData?.map((row, index) => {
                  const isItemSelected = isSelected(row.id);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      onClick={(event) => {}}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                      selected={isItemSelected}
                      sx={{ cursor: "pointer" }}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={isItemSelected}
                          inputProps={{
                            "aria-labelledby": labelId,
                          }}
                          // onClick={() => console.log("Checkbox clicked")}
                          onClick={() => handleCheckboxClick(row.id)}
                        />
                      </TableCell>
                      <TableCell align="center">
                        {row.id ? row?.id : ""}
                      </TableCell>
                      <TableCell align="center" sx = {{width: "250px"}}>
                        {row.email ? row?.email : "-"}
                      </TableCell>

                      <TableCell align="center">
                        {row?.f_name ? row?.f_name : ""}{" "}
                        {row?.m_name ? row?.m_name : ""}{" "}
                        {row?.l_name ? row?.l_name : ""}
                      </TableCell>
                      <TableCell align="center">
                        {row.mobile ? row?.mobile : "-"}
                      </TableCell>
                      <TableCell align="center">
                        {row.gender ? row?.gender : "-"}
                      </TableCell>
                      <TableCell align="center">
                        <Switch
                          {...label}
                          defaultChecked
                          onChange={() => {
                            handleSwitchChange(row.id);
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  )
                  })
                ) : (
                  <TableRow>
                      <TableCell colSpan={headCells.length} align="center">
                        <img src={Loading}/>
                        </TableCell>
                    </TableRow>
                )
              )}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: (dense ? 33 : 53) * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <CustomPagination
          count={pages?.total}
          rowsPerPage={rowsPerPage}
          page={activePage-1}
          handleChangePage={() => {}}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          handlePageChange={handlePageChange}
          pageNo={maxPage}
          noOfPages={noOfPages}
          activePage={activePage}
          showPrevPage={showPrevPage}
          showNextPage={showNextPage}
        />
      </Paper>
    </Box>
  );
};

export default RetailerTable;
